export function digits(parameters) {
  const [length] = parameters;
  return {
    length
  };
}
